import { cn } from "@/lib/utils";
import { statusChipClass, statusLabel, type PILStatus } from "@/lib/mapping-status-colors";

interface PILStatusChipProps {
  status: PILStatus | string;
  className?: string;
}

// Mapper-facing label: "in_progress" (location has some done PILs but more to go)
// should read "Done" from the mapper's perspective — the "in_progress" nuance is
// only useful to admins reviewing submissions later.
function mapperLabel(status: string): string {
  if (status === "in_progress") return "Done";
  return statusLabel(status);
}

// Make "in_progress" visually match "done" (green) for the mapper too.
function mapperChipClass(status: string): string {
  if (status === "in_progress") return statusChipClass("done");
  return statusChipClass(status);
}

export function PILStatusChip({ status, className }: PILStatusChipProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium",
        mapperChipClass(status),
        className,
      )}
    >
      {mapperLabel(status)}
    </span>
  );
}
